/**
 * Group name for keyboard shortcuts that are active when the cell is selected.
 */
export const GRID_GROUP = 'gridDefault';
/**
 * Group name for keyboard shortcuts that are active when the cell editor is active.
 */
export const EDITOR_EDIT_GROUP = 'editorManager.handlingEditor';